import { Model } from '@vuex-orm/core'
import User from '@/store/models/User'

export default class TaskCardHistory extends Model {
  static entity = 'taskCardHistories'

  static primaryKey = 'id'

  static fields () {
    return {
      id: this.attr(null),
      projectId: this.attr(null),
      editorId: this.attr(null),
      taskCardId: this.attr(null),
      taskListId: this.attr(null),
      createdAt: this.string(null).nullable(),
      startAt: this.string(null).nullable(),
      endAt: this.string(null).nullable(),
      title: this.string(null).nullable(),
      description: this.string(null).nullable(),
      userIds: this.attr([]),
      projectLabelIds: this.attr([]),
      progress: this.number(null).nullable(),
      isFirst: this.boolean(false)
    }
  }

  enabledAttributes = [
    'taskListId',
    'startAt',
    'endAt',
    'title',
    'description',
    'userIds',
    'projectLabelIds',
    'progress'
  ]

  get changedAttributes() {
    return this.enabledAttributes.filter((enabledAttribute) => {
      return this[enabledAttribute] !== null
    }).map((enabledAttribute) => {
      return {
        key: enabledAttribute,
        value: this[enabledAttribute]
      }
    })
  }

  get createdAttributes() {
    const attributePriority = (key) => {
      switch (key) {
        case 'title': {
          return 1
        }
        case 'taskListId': {
          return 2
        }
        case 'startAt': {
          return 3
        }
        case 'endAt': {
          return 4
        }
        case 'progress': {
          return 5
        }
        case 'projectLabelIds': {
          return 6
        }
        case 'description': {
          return 7
        }
        case 'userIds': {
          return 7
        }
        default: {
          return 100
        }
      }
    }
    return this.changedAttributes.slice().sort((a, b) => {
      return attributePriority(a.key) - attributePriority(b.key)
    })
  }

  get editor() {
    return User.find(this.editorId)
  }
}
